import React from 'react';
import styles from './W_NotFound.module.css';
import A_NotFound from '@/assets/images/A_NotFound.png';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

export default function W_NotFound() {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  return (
    <div className={styles.wrapper}>
      <div className={styles.circle_1}></div>
      <div className={styles.circle_2}></div>
      <div className={styles.image_wrapper}>
        <img src={A_NotFound} alt='NotFound' />
      </div>
      <span className={styles.title}>404</span>
      <span className={cn(styles.text, 'text-p-6')}>
        {t('common.pageNotFound')}
      </span>
    </div>
  );
}
